import React from "react";
import { DatePicker } from "antd5";
import dayjs, { Dayjs } from "dayjs";

import FormItemWrapper, { errorStatus } from "../FormItemWrapper";

import css from "../formStyles.module.scss";

type DateProps = {
  id?: string;
  label: string;
  required?: boolean;
  value: number;
  updateValue: (value: string | string[]) => void;
  errors: string;
  description?: string;
};

export function Date({
  id,
  label,
  required,
  value,
  updateValue,
  errors,
  description,
}: DateProps): JSX.Element {
  const handleInputChange = (_: Dayjs | null, dateString: string | string[]) => {
    updateValue(dateString);
  };

  return (
    <FormItemWrapper
      formIdentifier="string"
      label={label}
      required={required}
      errors={errors}
      description={description}
    >
      <DatePicker
        status={errorStatus(errors)}
        id={id}
        // Controlled rather than defaulted, because a form seeded from the CRM fills its data in
        // after the first render — which an uncontrolled picker, having read its value at mount,
        // never sees.
        value={value ? dayjs(value, "YYYY-MM-DD") : null}
        onChange={handleInputChange}
        className={css.fullWidth}
        style={{ zIndex: "100000" }}
        getPopupContainer={(node) => node}
      />
    </FormItemWrapper>
  );
}
